module.exports = __webpack_public_path__ + "static/impact-analysis-drones-20a0b6d9d7ba7e17d016f0eee0da76ec.png";